<template>
  <button :class="$style['button']">
    <IconCloseCircle :class="$style['button__icon']" />
  </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import IconCloseCircle from '@/components/icons/IconCloseCircle.vue'

export default defineComponent({
  name: 'ButtonCircleClose',
  components: {
    IconCloseCircle,
  },
})
</script>

<style lang="scss" module>
.button {
  border: 0;
  background-color: transparent;
  line-height: 0;

  &:hover {
    cursor: pointer;
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }

  &__icon {
    color: inherit;
    font-size: inherit;
  }
}
</style>
